// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { API_URL } from 'src/shared/api';
import { catchError } from 'rxjs/operators';
import { IAdminSettings } from 'src/types/admin-settings';
import { ConfigurationService } from './configuration-service';

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsService {

  constructor(
      private http: HttpClient,
      private translate: TranslateService,
      private configurationService: ConfigurationService,) { }

    getUrl(suffix: string) {
        return `${this.configurationService.apiUrl}${suffix}`;
    }

  getAdminSettings(selectedOrgId = ''): Observable<IAdminSettings> {
    let url = this.getUrl(`${API_URL.ADMIN_SETTINGS}`);
    if ( selectedOrgId.length > 0 ) {
      url += '?selectedOrgId=' + selectedOrgId;
    }
    return this.http.get<IAdminSettings>(url)
        .pipe(catchError(this.handleError.bind(this)
    ));
  }

  updateAdminSetting(settings: IAdminSettings, selectedOrgId = ''): Observable<string> {
    let url = this.getUrl(`${API_URL.ADMIN_SETTINGS}`);
    if ( selectedOrgId.length > 0 ) {
      url += '?selectedOrgId=' + selectedOrgId;
    }

    return this.http.put<IAdminSettings>(url, settings)
        .pipe(catchError(this.handleError.bind(this)
    ));
  }

  handleError(errResponse: HttpErrorResponse | any): any {
    if ((errResponse instanceof HttpErrorResponse) && errResponse?.error?.status) {
        return new Promise((resolve, reject) => {
            this.translate.get(errResponse.error.status).subscribe(
                (translated) => reject(translated),
                (err) => reject('Server Error')
            );
        });
    }
    return throwError(errResponse.error || 'Server error');
  }
}
